/** Named in the access-denied toast when a role outside INTERNAL_ROLES opens this module (ADR-0014). */
export const ACTIVITY_LOG_PAGE_NAME = 'Activity Log';
